import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts'
import type { PoolIpSummary } from '@/api/types'

interface IpPoolDonutProps {
  summary: PoolIpSummary
}

const statusColors: Record<string, string> = {
  available: 'hsl(142.1 76.2% 36.3%)',
  reserved: 'hsl(47.9 95.8% 53.1%)',
  assigned: 'hsl(221.2 83.2% 53.3%)',
  blacklisted: 'hsl(0 84.2% 60.2%)',
}

export function IpPoolDonut({ summary }: IpPoolDonutProps) {
  const data = [
    { name: 'Available', value: summary.available, color: statusColors.available },
    { name: 'Reserved', value: summary.reserved, color: statusColors.reserved },
    { name: 'Assigned', value: summary.assigned, color: statusColors.assigned },
    { name: 'Blacklisted', value: summary.blacklisted, color: statusColors.blacklisted },
  ].filter((d) => d.value > 0)

  if (data.length === 0) {
    return (
      <div className="flex h-[200px] items-center justify-center text-muted-foreground">
        No IPs in pool
      </div>
    )
  }

  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={70}
          paddingAngle={2}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: 'hsl(var(--card))',
            border: '1px solid hsl(var(--border))',
            borderRadius: '8px',
          }}
        />
        <Legend
          verticalAlign="bottom"
          height={36}
          formatter={(value) => <span className="text-sm text-foreground">{value}</span>}
        />
      </PieChart>
    </ResponsiveContainer>
  )
}
